export const createUserSlice = (set: any, get: any) => ({
  token: undefined,
  isAuth: false,
  userData: {},
});